export default __webpack_public_path__ + "static/app-store-download-white-a2dabe8749e99a31ca36103b5e64fc0c.svg";